import * as React from 'react';
import { Navigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';

interface AuthGuardType {
  children: React.ReactNode;
}

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }: AuthGuardType) {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    // While AuthProvider is checking the session, show a loading state or nothing.
    // This prevents premature redirects.
    return null; // Or render nothing
  }

  if (!isAuthenticated) {
    // Now that we are initialized, if not authenticated, redirect to login.
    return <Navigate to={"/"} replace />;
  }

  // If initialized and authenticated, render the protected content.
  return <React.Fragment>{children}</React.Fragment>;
}

export default AuthGuard;
